import Footer from "../../component/Footer";
import { useState, useEffect } from "react";
import AgentNavbar from "../../component/AgentNavbar";
import { useLocation } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";

function BusResult() {
  const location = useLocation();
  const [busResults, setBusResults] = useState([]);
  const [loading, setLoading] = useState(true);

  // Extract query parameters
  const searchParams = new URLSearchParams(location.search);
  const from = searchParams.get("from");
  const to = searchParams.get("to");
  const dateOfJourney = searchParams.get("dateOfJourney");
  useEffect(() => {
    if (from && to && dateOfJourney) {
      setLoading(true);
  
      const requestData = { from, to, dateOfJourney };
      
      console.log("Sending bus search request:", requestData); // Log request data
  
      axios
        .post(`${baseurl}searchbus`, requestData) // Sending as POST request
        .then((response) => {
          console.log("Bus search response:", response.data); // Log response data
          setBusResults(response.data.buses || []);
        })
        .catch((error) => {
          console.error("Error fetching bus results:", error);
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [from, to, dateOfJourney]);
  
  

  return (
    <>
      <AgentNavbar />
      <div className="container bg-2 midle">
        <h1>Bus Search Results</h1>
        <p>
          <strong>From:</strong> {from} | <strong>To:</strong> {to} | <strong>Date:</strong> {dateOfJourney}
        </p>
        <hr />

        {loading ? (
          <p>Loading bus results...</p>
        ) : busResults.length > 0 ? (
          <ul>
            {busResults.map((bus, index) => (
              <li key={index}>
                <strong>{bus.name}</strong> - {bus.time} - {bus.price}
              </li>
            ))}
          </ul>
        ) : (
          <p>No buses found for the selected route.</p>
        )}
      </div>
    </>
  );
}

export default BusResult;
